<template>
    <el-card class="blue-widget">
        <div v-if="$slots.header" slot="header">
            <slot name="header"></slot>
        </div>
        <div class="notification-body-container">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{'active': notificationStatus === 'unread'}"
                        @click="notificationStatus = 'unread'"
                    >Unread
                    </button>
                </li>
                <li class="nav-item">
                    <button
                        class="nav-link"
                        :class="{'active': notificationStatus === 'all'}"
                        @click="notificationStatus = 'all'"
                    >All
                    </button>
                </li>
            </ul>
            <div class="container d-flex py-2 notification-col-header">
                <div class="w-25">
                    <strong>Title</strong>
                </div>
                <div class="w-60">
                    <strong>Details</strong>
                </div>
                <div class="w-15">
                    <strong>Actions</strong>
                </div>
            </div>
            <div
                v-if="(showNotifications.length == 0 && notificationStatus == 'all') || (unreadNotifications.length == 0 && notificationStatus == 'unread') "
                v-loading="loading"
                class="d-flex justify-content-center notifications-container mix-blend-mode-multiple">
                <div class="my-3">No notifications found</div>
            </div>
            <div v-else v-loading="loading" class="notifications-container mix-blend-mode-multiple">
                <div class="amb-notification-card d-flex px-3 mb-1"
                    v-bind:class="{success: notification.run, danger: !notification.run}"
                    v-for="(notification, index) in notificationStatus == 'unread' ? unreadNotifications : showNotifications"
                    :key="index">
                    <div class="w-25">
                        <p class="font-12 mb-0" :class="!notification.deleted_at ? 'font-weight-bold' : ''">
                            {{ notification.applicant ? notification.applicant.full_name || '' : '' }} {{
                                notification.application ? notification.application.ref_id || notification.title : notification.title || ''
                            }}</p>
                    </div>
                    <div class="w-60">
                        <p class="font-12 mb-0" v-html="notification.message"></p>
                        <p class="font-12 mb-0" >{{ formatDate( notification.created_at )}}</p>
                    </div>
                    <div class="w-15 d-flex py-2 pl-3">
                        <a target="_blank" class="has-interaction card-action-view mt-1"
                        @click="openNotification(notification.url)"><i class="fas fa-eye"></i></a>
                        <p v-if="!notification.deleted_at"
                        class="my-1 ml-3 has-interaction text-danger card-action-dismiss"
                        @click.stop="deleteNotification(notification.id, index)">
                            <i class="fas fa-times-circle fa-lg"></i>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <pagination
                :total="allNotifications.total"
                :page.sync="allNotifications.current_page"
                :limit.sync="allNotifications.per_page"
                @pagination="getNotifications(false)"
                @sizeChange="getNotifications(true)"
            />
        </div>
    </el-card>
</template>

<script>
import {mapGetters} from 'vuex';
import Pagination from "@shared/components/pagination"
import moment from 'moment';
export default {
    name: 'DashboardNotifications',
    props: ['teamId', 'brokerId'],
    components: {
        Pagination,
    },
    data() {

        return {
            loading: false,
            notificationStatus: 'unread',
            allNotifications: [],
            showNotifications: [],
            pagination: {},
        }
    },
    computed: {
        ...mapGetters({
            user: "user/user",
            unreadNotifications: 'notifications/dashboardNotifications',
            count: 'notifications/totalCount'
        }),
    },
    watch: {
        notificationStatus(newVal, oldVal) {
            if (newVal === 'all') {
                this.getNotifications();
            }
        },
        teamId() {
            this.getNotifications();
        },
        brokerId() {
            this.getNotifications();
        }
    },
    created() {
        this.$bus.$on("refreshed-data", value => {
            this.getNotifications();
        });
    },
    methods: {
        getNotifications: function () {
            let self = this;

            let headers = Object.assign({}, {
                params: {
                    notificationStatus: this.notificationStatus,
                    teamId: this.teamId,
                    brokerId: this.brokerId,
                    page: _.get(this.allNotifications, 'current_page', 1),
                    per_page: _.get(this.allNotifications, 'per_page', 10),
                }
            });

            this.loading = true;

            this.$tenant
                .get("/api/notifications", headers)
                .then(res => {
                    self.allNotifications = res.data;
                    self.showNotifications = self.allNotifications;
                    this.pagination = res.data
                    
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatDate(value) {
            if (value) return moment.utc(value).tz(this.user.timezone).format("ddd DD/MM/YY LT")
            else return null
        },
        deleteNotification(id, index) {
            this.$store.dispatch("notifications/deleteNotification", {id, index})
        },
        openNotification(url) {
            window.open(url);
        }
    },
}
</script>

<style scoped>

.notification-body-container .notifications-container {
    height: 480px;
    overflow-y: scroll;
}

.notification-body-container .notifications-container.el-loading-parent--relative {
    overflow: hidden;
}

.amb-notification-card {
    background-color: #f3f3f3;
}

</style>
